import classNames from "classnames"
import React from "react"
import { scrollToElement } from "../../../../ui/utilities/scrolling"
import { last } from "../../../../utils/array"
import { useAlgoliaSearchState } from "../controller/state"
import {
  filterPageIndexes,
  getAllPagesIndexes,
  isFirstPage,
  isLastPage,
} from "../utils/paging"
import classes from "./AlgoliaResultsPaginator.module.css"

export const AlgoliaResultsPaginator = () => {
  const {
    searchParams,
    searchResults,
    updateSearchPage,
  } = useAlgoliaSearchState()

  const handleClick = (page: number) => {
    updateSearchPage(page)
    scrollToElement("resultsContainer")
  }

  if (!searchResults || searchResults?.nbPages <= 1) {
    return <></>
  }

  const currentPage = searchParams.page ?? 1
  const pageIndexes = getAllPagesIndexes(searchResults.nbPages)
  const filteredIndexes = filterPageIndexes(pageIndexes, currentPage)

  const lastFilteredIndex = last(filteredIndexes)
  const lastPageIndex = searchResults.nbPages
  const firstFilteredIndex = filteredIndexes[0]

  return (
    <ul className="flex items-center justify-center">
      {isFirstPage(currentPage) ? (
        <li className={classNames(classes.link, classes.linkDisabled)}>
          <span>←</span>
        </li>
      ) : (
        <li
          className={classes.link}
          onClick={() => {
            handleClick(1)
          }}
        >
          <a>←</a>
        </li>
      )}

      {firstFilteredIndex !== undefined && firstFilteredIndex > 1 ? (
        <li
          key={1}
          className={classNames(classes.link, classes.linkNoMobile, {
            [classes.linkActive]: currentPage === 1,
          })}
          onClick={() => {
            handleClick(1)
          }}
        >
          <a>{1}</a>
        </li>
      ) : (
        <></>
      )}

      {firstFilteredIndex !== undefined && firstFilteredIndex >= 3 ? (
        <li className="hidden mx-1 sm:block">...</li>
      ) : (
        <></>
      )}

      {filteredIndexes.map((page) => {
        return (
          <li
            key={page}
            className={classNames(classes.link, {
              [classes.linkActive]: currentPage === page,
            })}
            onClick={() => {
              handleClick(page)
            }}
          >
            <a>{page}</a>
          </li>
        )
      })}

      {lastFilteredIndex !== undefined &&
      lastFilteredIndex + 1 < lastPageIndex ? (
        <li className="hidden mx-1 sm:block">...</li>
      ) : (
        <></>
      )}

      {lastFilteredIndex && lastFilteredIndex < lastPageIndex ? (
        <li
          key={lastPageIndex}
          className={classNames(classes.link, classes.linkNoMobile, {
            [classes.linkActive]: currentPage === lastPageIndex,
          })}
          onClick={() => {
            handleClick(lastPageIndex)
          }}
        >
          <a>{lastPageIndex}</a>
        </li>
      ) : (
        <></>
      )}

      {isLastPage(currentPage, searchResults.nbPages) ? (
        <li className={classNames(classes.link, classes.linkDisabled)}>
          <span>→</span>
        </li>
      ) : (
        <li
          className={classes.link}
          onClick={() => {
            handleClick(currentPage + 1)
          }}
        >
          <a>→</a>
        </li>
      )}
    </ul>
  )
}
